import { render } from "./demo-day-auction-order-information.vue?vue&type=template&id=1e41bc47"
import script from "./demo-day-auction-order-information.vue?vue&type=script&lang=js"
export * from "./demo-day-auction-order-information.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__